import React, { Component, Fragment } from 'react';

import { withRouter } from 'react-router-dom';

import { Mutation } from 'react-apollo';

import RemoveIcon from 'react-icons/lib/fa/times-circle';
import debounce from 'lodash.debounce';
import get from 'lodash.get';

import PeoplePage from './PeoplePage';

import { personToPath } from '../utils';
import {
  UPSERT_PERSON_MUTATION,
  PEOPLE_QUERY,
  peopleQueryVariables,
} from '../graphql.js';

const defaultState = { query: '', debouncedQuery: '' };
export class SearchablePeoplePage extends Component {
  state = defaultState;

  updateDebouncedQueryNow = () => {
    this.updateDebouncedQuery.cancel();
    this.setState({ debouncedQuery: this.state.query });
  };

  updateDebouncedQuery = debounce(() => {
    this.updateDebouncedQueryNow();
  }, 300);

  componentDidUpdate(prevProps, prevState) {
    const person = get(this.props.upsertPersonData, 'person');
    const personId = get(person, 'id');
    const previousPersonId = get(prevProps, 'upsertPersonData.person.id');

    if (personId && previousPersonId !== personId) {
      this.props.history.push(personToPath(person));
      this.setState(defaultState);
    }
  }

  render() {
    const {
      upsertPerson,
      upsertPersonLoading,
      upsertPersonError,
      upsertPersonData,
    } = this.props;
    const { query, debouncedQuery } = this.state;

    return (
      <Fragment>
        <form
          style={{ paddingTop: 10 }}
          className="form-inline d-flex justify-content-sm-between"
          onSubmit={e => {
            e.preventDefault();
            this.updateDebouncedQueryNow();
          }}
        >
          <div
            style={{
              position: 'relative',
              flex: 1,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <input
              className="form-control"
              style={{ flex: 1 }}
              type="search"
              placeholder="Search. Try &quot;#microconf&quot;"
              aria-label="Search"
              value={query}
              onChange={e =>
                this.setState(
                  { query: e.target.value },
                  this.updateDebouncedQuery
                )
              }
            />
            {query && (
              <RemoveIcon
                style={{ position: 'absolute', right: 15, cursor: 'pointer' }}
                onClick={() =>
                  this.setState({ query: '' }, this.updateDebouncedQueryNow)
                }
              />
            )}
          </div>
          {false && (
            <button className="btn btn-outline-primary" type="submit">
              search
            </button>
          )}
          {false &&
            query && (
              <button
                className="btn btn-primary d-none"
                type="button"
                // onClick={() => {
                // console.log(`adding ${query}`);
                // }}
              >
                add
              </button>
            )}
        </form>

        {query &&
          debouncedQuery && (
            <button
              style={{ marginTop: 5 }}
              className="btn btn-primary btn-block"
              onClick={() => {
                upsertPerson({ name: query });
              }}
            >
              add "{query}"
            </button>
          )}

        <PeoplePage query={debouncedQuery} />
      </Fragment>
    );
  }
}

export default withRouter(props => (
  <Mutation mutation={UPSERT_PERSON_MUTATION}>
    {(upsertPost, { loading, error, data }) => (
      <SearchablePeoplePage
        {...props}
        upsertPerson={person => {
          upsertPost({
            variables: person,
            // this works but is unnecessary with update?
            // refetchQueries: props.refetchQueries,
            // optimisticResponse: {
            //   __typename: 'Mutation',
            //   post: {
            //     id: -1,
            //     created_at: new Date(),
            //     updated_at: new Date(),
            //     date: new Date(),
            //     body: 'optimistic body',
            //     __typename: 'Post',
            //   },
            // },
            update: (store, { data: { person } }) => {
              // this feels so gross
              const query = PEOPLE_QUERY;
              const variables = peopleQueryVariables;
              const data = store.readQuery({ query, variables });
              data.people.unshift(person);
              store.writeQuery({ query, variables, data });
            },
          });
        }}
        upsertPersonLoading={loading}
        upsertPersonError={error}
        upsertPersonData={data}
      />
    )}
  </Mutation>
));



// WEBPACK FOOTER //
// ./src/pages/SearchablePeoplePage.js